import moment from 'moment';
import React, { useMemo, useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { HiOutlinePencilAlt, HiChat } from 'react-icons/hi';
import MainPageDialog from '../../components/dialog';
import VezoCallBtn from '../../components/vezoCallBtn';
import { useGroupChatContext } from '../../context/groupchatContext';
import { useGetPatientAppointmentQuery } from '../../services/appointmentService';
import { AppointmentsFollowUp } from './followupAppointment';
import { OptimalCarePracticeID } from '../../utils/constant';
const PatientAppointment = ({ practiceId, isNursingPractice }) => {

    const [openAppt, setOpenAppt] = useState({ isOpen: false })

    const groupChatContext = useGroupChatContext();
    const { authData, selectedChat } = useMemo(() => ({
        authData: groupChatContext.authData,
        selectedChat: groupChatContext.selectedChat,
    }));

    const { data: appointmentsResponse, isLoading } = useGetPatientAppointmentQuery({ location_uuid: selectedChat?.location?.uuid, pid: selectedChat.pid, end_date: moment().add(30, 'days').format('YYYY-MM-DD') }, { refetchOnMountOrArgChange: true });
    const appointments = appointmentsResponse?.data || [];

    return (
        <>
            {/* {isLoading ? 
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto absolute inset-0 outline-none focus:outline-none before:absolute before:flex before:w-full before:h-full z-[999]">
                    <FaSpinner className="animate-spin text-green-300-500 ml-1" size={40} />
                </div>
                : null
            } */}

            {appointments?.map((item, index) => (
                <div key={index} className={`items-start gap-2 w-full transition-colors duration-300 ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} ${index != appointments.length - 1 ? 'border-b border-gray-200' : ''}`}>
                    {item.data.map((appt) => (
                        <div key={appt.id} className='pt-2'>
                            <div className='flex py-0 items-center justify-between align-middle'>
                                <div>
                                    <span className='font-bold'>{moment(appt.start_time).format('MM/DD/YYYY')}</span>
                                    {!isNursingPractice && <span className='pl-2'>{moment(appt.start_time).format('hh:mm A')}</span>}
                                </div>
                                {(authData?.is_provider) ? <HiOutlinePencilAlt title="Edit Appointment" onClick={() => setOpenAppt({ isOpen: true, id: appt.id })} className="h-5 w-5 cursor-pointer" /> : null}
                            </div>
                            {practiceId !== OptimalCarePracticeID && <div className='flex items-center justify-between pt-2 gap-2'>
                                <span className='flex text-left'>{appt.provider_name}</span>
                                <span>{appt.status}</span>
                                <span>
                                    <HiChat title={appt.comments} className={`h-5 w-5 ${appt.comments ? 'text-green-600' : ''}`} />
                                </span>
                            </div>
                            }
                            {(appt.vezo_visit_key || appt.vezo_visit_url) ?
                                <div className='border-t-2 mt-1'>
                                    <VezoCallBtn item={{ visit_key: appt.vezo_visit_key, visit_url: appt.vezo_visit_url }} />
                                </div>
                                : null}
                        </div>
                    ))}
                </div >
            ))}
            {
                !appointments?.length ?
                    <div className="container mx-auto">
                        <p className="text-gray-600 text-lg">No appointment scheduled</p>
                    </div>
                    : null
            }

            {
                openAppt.isOpen ?
                    <MainPageDialog
                        title="Edit Appointment"
                        onCancelHandler={() => setOpenAppt({ isOpen: false })}
                        // modalSize="md"
                        maxHeight={true}
                        customHeight={"min-h-[80vh] overflow-y-auto"}
                        component={
                            <AppointmentsFollowUp apptId={openAppt.id} closeApptPopup={() => setOpenAppt({ isOpen: false })} />
                        }
                        footer={false}
                    >
                    </MainPageDialog>
                    : null
            }
        </>
    );
};

export default PatientAppointment;
